module.exports = __webpack_public_path__ + "img/light.234233e1.gif";